import { fetchData } from './api_helper';

const sendMessageToBot = msg => new Promise(((resolve, reject) => {
  fetchData(`${msg.url}/WEBINTERFACE/SPEECH/api.php`, 'post', msg).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

export default {
  sendMessageToBot
};



// WEBPACK FOOTER //
// ./src/api/teachbot.js